import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { maintenanceNoticeTimeText } from './support-operating-hours-notice.config';

@Component({
  selector: 'app-support-operating-hours-notice',
  templateUrl: './support-operating-hours-notice.component.html',
  styleUrls: ['../downtime-warning/downtime-warning.component.css'],
})
export class SupportOperatingHoursNoticeComponent {
  timeText = maintenanceNoticeTimeText();

  constructor(
    private dialogRef: MatDialogRef<SupportOperatingHoursNoticeComponent>
  ) {}

  close() {
    this.dialogRef.close();
  }
}
